/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/addresses';

export const AddressApi = {
  createWithType: async (body: CreateAddressBody) => {
    try {
      const url = `${pathname}/create`;
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface AddressData {
  id?: string;
  ownerID: string;
  districtCode: string;
  provinceCode: string;
  wardCode: string;
  isSelected?: boolean;
  address: string;
  title: string;
  isPhoneNumberVerified?: boolean;
  phoneNumber: string;
  latitude?: string;
  longitude?: string;
  district?: any;
  province?: any;
  ward: {
    id: string;
    code: string;
    fullName?: string;
    districtCode?: string;
    provinceCode?: string;
    district?: any;
    province?: any;
  };
  isSupplierCreateForPartner?: boolean;
  disabledUpdateRemove?: boolean;
  key?: string;
  notExisted?: boolean;
  isHome?: boolean;
}

export interface CreateUpdateAddressBody {
  id?: string;
  ownerID?: string;
  districtCode: string;
  provinceCode: string;
  wardCode: string;
  isSelected?: boolean;
  address: string;
  title: string;
  isPhoneNumberVerified?: boolean;
  phoneNumber: string;
  latitude?: string;
  longitude?: string;
  district?: any;
  province?: any;
  isHome?: boolean;
}

export interface CreateAddressBody {
  id?: string;
  ownerID?: string;
  entityID?: string;
  supplierID?: string;
  districtCode: string;
  provinceCode: string;
  wardCode: string;
  isSelected?: boolean;
  address: string;
  title: string;
  isPhoneNumberVerified?: boolean;
  phoneNumber: string;
  latitude?: string;
  longitude?: string;
  district?: any;
  province?: any;
  isHome?: boolean;
}
